export const colors = {
  primary: "rgba(62, 119, 89, 1)",
  primaryDark: "rgba(53, 101, 76, 1)",
  primaryLight: "rgba(92, 125, 73, 1)",
  secondary: "rgba(255, 176, 0, 1)",
  secondaryDark: "rgba(210, 152, 9, 1)",
  tertiary: "rgba(42, 74, 57, 1)",
  tertiaryDark: "rgba(72, 59, 59, 1)",
  quaternary: "rgba(199, 199, 199, 1)",
  secondaryBackground: "rgba(56, 67, 61,1)",
  secondaryText: "rgba(217, 62, 49, 1)",
  cardGreen: "#92BA50",
  tieColor: "#f98303",
  closeStrokeColor: "rgba(62, 119, 89, 1)",
}
